import Immutable from 'immutable';

const ImageRecord = Immutable.Record({
  id: 0,
  avg: '',
  caption: Immutable.List(),
  type: 'image',
  url: '',
  xlargeUrl: '',
  smallUrl: '',
  filename: '',
  width: 0,
  mediumUrl: '',
  mimetype: '',
  largeUrl: '',
  height: 0
});

class Image extends ImageRecord {
  isGif() {
    return this.filename && this.filename.indexOf('.gif') > 0;
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/models/image.js